import { Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { lazyRetry } from "./lazyRetry";
import Loader from "./components/Loader";
import "./App.css";

/* every page is its own chunk: the landing and the login never download the 3D engine */
const Landing = lazyRetry(() => import("./pages/Landing"));
const AuthPage = lazyRetry(() => import("./pages/AuthPage"));
const AuthCallback = lazyRetry(() => import("./pages/AuthCallback"));
const GamePage = lazyRetry(() => import("./pages/GamePage"));
const SagaSharePage = lazyRetry(() => import("./pages/SagaSharePage"));
const BookSharePage = lazyRetry(() => import("./pages/BookSharePage"));
const JoinPage = lazyRetry(() => import("./pages/JoinPage"));
const Showcase = lazyRetry(() => import("./pages/Showcase"));
const DownloadPage = lazyRetry(() => import("./pages/DownloadPage"));

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#14141C",
              border: "1px solid rgba(212,175,55,0.4)",
              color: "#FEF3C7",
              fontFamily: "Cinzel, serif",
            },
          }}
        />
        <Suspense fallback={<Loader />}>
          <AppRouter />
        </Suspense>
      </BrowserRouter>
    </AuthProvider>
  );
}

function AppRouter() {
  const location = useLocation();
  // Emergent Google auth lands on {origin}/game#session_id=... — handle it before any protected route runs
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route
            path="/game"
            element={
              <Protected>
                <GamePage />
              </Protected>
            }
          />
          <Route path="/saga/:token" element={<SagaSharePage />} />
          <Route path="/libro/:token" element={<BookSharePage />} />
          <Route path="/book/:token" element={<BookSharePage />} />
          <Route path="/join/:code" element={<JoinPage />} />
          <Route path="/showcase" element={<Showcase />} />
          <Route path="/scarica" element={<DownloadPage />} />
          <Route path="/install" element={<DownloadPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
  );
}
